import { storeRef } from "@/components/providers/StoreProvider"
import dayjs from "dayjs"

export const getQueryStringSearchFlight = () => {
  const flightState = storeRef.current?.getState().flight
  const inputAdult = flightState?.inputAdult || 0
  const inputChildren = flightState?.inputChildren || 0
  const inputInfant = flightState?.inputInfant || 0
  const checkedItinerary = flightState?.checkedItinerary
  const inputFlights = flightState?.inputFlights || []
  const cabinClass = flightState?.cabinClass || ''

  const isMultiCities = flightState?.isMultiCities

  const params = new URLSearchParams()
  params.set('adult', inputAdult)
  params.set('child', inputChildren)
  params.set('infant', inputInfant)
  params.set('itinerary', checkedItinerary && !isMultiCities ? '1' : '0')
  for (let i = 0; i < inputFlights.length; i++) {
    
    const input = inputFlights[i];
    if (input.isReturn) {
      continue
    }
    const toAirport = input.toAirport
    const fromAirport = input.fromAirport

    let dateFrom = input.dateFrom
    if (!dayjs.isDayjs(dateFrom)) {
      dateFrom = dayjs(dateFrom)
      if (!dateFrom.isValid()) {
        dateFrom = dayjs()
      }
    }

    let dateTo = input.dateTo
    if (!dayjs.isDayjs(dateTo)) {
      dateTo = dayjs(dateTo)
      if (!dateTo.isValid()) {
        dateTo = dayjs()
      }
    }

    params.set(`t${i + 1}`, toAirport?.code || '')
    params.set(`f${i + 1}`, fromAirport?.code || '')
    dateFrom && params.set(`df${i + 1}`, dateFrom.format("YYYY-MM-DD"))
    dateTo && checkedItinerary && params.set(`dt${i + 1}`, dateTo.format("YYYY-MM-DD"))
  }

  params.set('class', cabinClass)

  return params.toString()
}